import React, { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import CloseIcon from '../../images/close-button-black.png';
import ArrowDown from "../../images/arrowsDown.png"
import { doFetchCities, doFetchProvinces, saveShipping, updateHistoryShipping } from "../../actions/postalCodeAction"
import { connect } from "react-redux"
import { Modal } from "reactstrap"
import InputNumber from 'Reuseables/InputNumber/InputNumber';

function ModalEditAddressIdExpress({ data, id, title, onToggle, countries, isOpen, doFetchCities, doFetchProvinces, provinces, cities, toggleEdit, saveShipping, updateHistoryShipping }) {

  const [countryCode, setCountryCode] = useState(null)
  const [countryId, setCountryId] = useState(0)

  // Show active button when input
  const [showActiveButton, setShowActiveButton] = useState(false)

  // Form edit first data
  const [alias, setAlias] = useState(null)
  const [currentAddress, setCurrentAddress] = useState(null)
  const [currentFullName, setCurrentFullName] = useState(null)
  const [currentPostalCode, setCurrentPostalCode] = useState(null)
  const [currentNote, setCurrentNote] = useState(null)
  const [currentCountryCode, setCurrentCountryCode] = useState(null)
  const [currentPhoneNumber, setCurrentPhoneNumber] = useState(null)
  const [currentCountry, setCurrentCountry] = useState(null)
  const [currentProvince, setCurrentProvince] = useState(null)
  const [currentCity, setCurrentCity] = useState(null)

  // Initial render trigger button
  const [initialRender, setInitialRender] = useState(true)

  useEffect(() => {
    const temp = data.filter(item => item.id === id)[0]

    setAlias(temp.alias)
    setCurrentAddress(temp.street_address)
    setCurrentFullName(temp.full_name)
    setCurrentPostalCode(temp.postal_code)
    setCurrentNote(temp.note)
    setCurrentCountry(temp.country)
    setCurrentProvince(temp.province)
    setCurrentCity(temp.city)

    const countryCode = temp.phone_number.slice(1, 3)
    const phoneNumber = temp.phone_number.slice(3, temp.phone_number.length)

    setCurrentCountryCode(countryCode)
    setCurrentPhoneNumber(phoneNumber)

    currentCountry && doFetchProvinces(currentCountry)
    currentProvince && doFetchCities(currentCountry, currentProvince)
  }, [data])

  useEffect(() => {
    const temp = data.find(item => item.id === id)

    const checkCountryCode = temp.phone_number.slice(1, 3)
    const checkPhoneNumber = temp.phone_number.slice(3, temp.phone_number.length)

    if (temp.alias !== alias || temp.street_address !== currentAddress || temp.full_name !== currentFullName || temp.postal_code !== currentPostalCode || temp.note !== currentNote || temp.country !== currentCountry || temp.province !== currentProvince || temp.city !== currentCity || checkCountryCode !== currentCountryCode || checkPhoneNumber !== currentPhoneNumber) {
      setShowActiveButton(true)
    } else {
      setShowActiveButton(false)
    }

  }, [alias, currentAddress, currentFullName, currentPostalCode, currentNote, currentCountryCode, currentPhoneNumber, currentCountry, currentProvince, currentCity])

  useEffect(() => {
    currentCountry && doFetchProvinces(currentCountry)
      .then(data => {
        if (!initialRender) {
          setCurrentProvince(data.value.data[0].name)
        } else {
          setInitialRender(false)
        }
      })
      .catch(e => null)
  }, [currentCountry])

  useEffect(() => {
    currentProvince && doFetchCities(currentCountry, currentProvince)
  }, [currentProvince])

  function handleCountryChange(e) {
    setCurrentCountry(e.target.value)
  }

  function handleProvinceChange(e) {
    setCurrentProvince(e.target.value)
  }

  function handleCityChange(e) {
    setCurrentCity(e.target.value)
  }

  function handlePhoneNumber(e) {
    let event = e || window.event;

    // Handle key only accept number
    let key = event.keyCode || event.which
    key = String.fromCharCode(key)

    const regex = /[0-9]|\./

    if (!regex.test(key)) {
      event.returnValue = false
      if (event.preventDefault) event.preventDefault()
    }
  }

  async function updateShipping(id) {
    try {
      const payload = {
        id: "",
        alias: alias,
        full_name: currentFullName,
        phone_number: `+${currentCountryCode}${currentPhoneNumber}`,
        street_address: currentAddress,
        country: countryCode,
        city: currentCity,
        province: currentProvince,
        note: currentNote,
        postal_code: currentPostalCode,
      }

      await updateHistoryShipping(id, payload)
      onToggle()
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={onToggle}>
      <div className="add-address-container">
        <div className="add-address-header">
          <h4>{title}</h4>
          <div className="icon-close">
            <KickImage style={{ cursor: "pointer" }} onClick={() => onToggle()} src={CloseIcon} alt="close" />
          </div>
        </div>
        <div className="add-address-content">
          <div>
            <label>Save address as</label><br />
            <input onChange={(e) => setAlias(e.target.value)} value={alias} type="text" placeholder="Save Address As (Ex. Office)" />
          </div>
          <div>
            <label>Recipient</label><br />
            <input onChange={(e) => setCurrentFullName(e.target.value)} value={currentFullName} type="text" placeholder="Recipient" />
          </div>
          <div>
            <label>Phone Number</label><br />
            <div className="add-address-phone-input">
              <select onChange={e => setCurrentCountryCode(e.target.value)} value={currentCountryCode} style={{ background: `url(${ArrowDown})` }}>
                {
                  countries && countries.map(item => (
                    <option value={item.phone_code}>{`+${item.phone_code}`}</option>
                  ))
                }
              </select>
              <InputNumber onChange={(e) => setCurrentPhoneNumber(e.target.value)} value={currentPhoneNumber} placeholder="Phone Number" />
            </div>
          </div>
          <div>
            <label>Address</label><br />
            <input onChange={(e) => setCurrentAddress(e.target.value)} value={currentAddress} type="text" placeholder="Address" />
          </div>
          <div className="add-address-flex-inputs">
            <div>
              <label>Country</label><br />
              <select onChange={handleCountryChange} value={currentCountry} style={{ background: `url(${ArrowDown})` }} value={currentCountry} name="" id="">
                {
                  countries && countries.map(item => (
                    <option value={item.code3}>{item.name}</option>
                  ))
                }
              </select>
            </div>
            <div>
              <label>Province</label><br />
              <select onChange={handleProvinceChange} value={currentProvince} style={{ background: `url(${ArrowDown})` }} name="" id="">
                {
                  provinces && provinces.map(item => (
                    <option value={item.name}>{item.name}</option>
                  ))
                }
              </select>
            </div>
          </div>
          <div className="add-address-flex-inputs">
            <div style={{ marginRight: "20px" }}>
              <label>City</label><br />
              <select onChange={handleCityChange} value={currentCity} style={{ background: `url(${ArrowDown})` }} name="" id="">
                <option value="" disabled hidden selected>Select City</option>
                {
                  cities && countryCode !== "SGD" ? cities.map(item => (
                    <option key={item.id} value={item.name}>{item.name}</option>
                  )) : <option>Cities option not found..</option>
                }
              </select>
            </div>
          </div>
          <div>
            <label htmlFor="">Zip Code</label><br />
            <input onChange={(e) => setCurrentPostalCode(e.target.value)} value={currentPostalCode} type="number" placeholder="Enter Zip Code" />
          </div>
          <div>
            <label>Note</label><br />
            <input onChange={(e) => setCurrentNote(e.target.value)} value={currentNote} type="text" placeholder="Enter Note Here(Optional)" />
          </div>
        </div>
        <div className="add-address-footer">
          <span onClick={() => onToggle()}>Cancel</span>
          <span style={showActiveButton ? { backgroundColor: "#242424", color: "#f1f1f1", cursor: "pointer" } : { backgroundColor: "#a7a7a7", border: "2px solid #a7a7a7", cursor: "normal" }} onClick={showActiveButton ? () => updateShipping(id) : null}>Save</span>
        </div>
      </div>
    </Modal>
  )
}

const mapStateToProps = state => ({
  provinces: state.dataPostalCode.provinces.data,
  cities: state.dataPostalCode.cities.data,
})

const mapDispatchToProps = dispatch => ({
  doFetchProvinces: country => dispatch(doFetchProvinces(country)),
  doFetchCities: (country, province) => dispatch(doFetchCities(country, province)),
  saveShipping: (payload) => dispatch(saveShipping(payload)),
  updateHistoryShipping: (id, payload) => dispatch(updateHistoryShipping(id, payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ModalEditAddressIdExpress)
